/**
 * sessionStorage key shared between Issues (SPA) and Projects (partial)
 * so collapse state persists across hard navigations.
 */
export const SIDEBAR_STORAGE_KEY = 'issue_index_sidebar_expanded'
